/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Config from "data/config";
import { Logtail } from "@logtail/browser";
import { logOptions } from "cms/utils/log/log-options";
import { cloudLog } from "cms/utils/log/log-helpers";
import { getLine, getStackFrames } from "cms/utils/log/stack";
// import { magentaBright, green,yellowBright, red } from "cms/utils/log/colors";
// import { transformSourceMap, initializeSourceMap } from "utils/log/sourcemaps"
// initializeSourceMap()

const source_token = Config.Logging.SourceToken;
const hasCloud = source_token;
const enableConsole = Config.Logging.enableConsole;
const rebuildStack = Config.Logging.rebuildStack;
// const enableConsole = false
const disableCloud = Config.Logging.disableCloud;
if (enableConsole) {
    // logOptions.sendLogsToConsoleOutput = true
}
if (disableCloud) {
    logOptions.sendLogsToBetterStack = false;
}

// Interceptor for the log
const developerLog = (log) => {
    if (log.level === "error") {
        const error = log?.error;
        // const stack = new Error().stack;
        const stack = error?.stack;
        // // console.info(`stack: ${stack}`);
        const message = error?.message;
        // const error_message = `[${log.dt.toISOString()}] 🌆 [${log.level.toUpperCase()}] ${log.message} ${message} \n${log?.error?.stack}`
        // const error_message = `${log.message} ${message} \n${file_line} \n${stack}`
        const error_message = `${log.message} ${message} \n${stack}`;
        // const message = `[${log.dt.toISOString()}] [${log.level}] [${log?.error?.code}] ${log.error.message}`
        // const message = `[${log?.error?.code}] ${log?.error?.message}\n${log?.stack}`
        log.message = error_message;
        log = cloudLog(log, log.level);
    } else if (log.level === "warn") {
        log = cloudLog(log, log.level);
    } else {
        log = cloudLog(log, log.level);
    }
    return log;
};

const SimpliCityLogger = () => {
    if (enableConsole) {
        console.debug("%c[SimpliCityLogger] initializing", "color: lime");
    }
    let LogService;
    if (hasCloud) {
        LogService = new Logtail(source_token, logOptions);
        LogService.use(developerLog);
    }
    const debug = async function (...args) {
        if (enableConsole) {
            console.debug(...args);
            // const argz = await rebuildArgs("debug", magentaBright, ...args);
            // console.debug(...argz);
        }
        if (hasCloud) {
            await LogService.debug(...args);
        }
    };
    const info = async function (...args) {
        if (enableConsole) {
            console.info(...args);
            // const argz = await rebuildArgs("info", green, ...args);
            // console.info(...argz);
        }
        if (hasCloud) {
            await LogService.info(...args);
        }
    };
    const log = async function (...args) {
        if (enableConsole) {
            console.log(...args);
            // const argz = await rebuildArgs("log", green, ...args);
            // console.log(...argz);
        }
        if (hasCloud) {
            await LogService.log(...args);
        }
    };
    const warn = async function (...args) {
        if (enableConsole) {
            console.warn(...args);
            // const argz = await rebuildArgs("warn", yellowBright, ...args);
            // console.warn(...argz);
        }
        if (hasCloud) {
            await LogService.warn(...args);
        }
    };
    const error = async function (...args) {
        console.error(...args);
        // if (enableConsole) {
        //     const argz = await rebuildArgs("error", red, ...args);
        //     const last = argz[argz.length - 1];
        //     const stack = last?.stack.trace;
        //     console.error(stack);
        //     console.error(...argz);
        // }
        if (hasCloud) {
            await LogService.error(...args);
        }
    };
    // eslint-disable-next-line no-unused-vars
    const rebuildArgs = async function (type, color, ...args) {
        const data = args[1];
        const stack = new Error().stack;
        const frames = await getStackFrames(stack);
        frames.splice(0, 1);
        const file_line = await getLine(stack);
        const firstArg = args[0];
        const isString = typeof firstArg === "string";
        const prefix = color(`[${type}]${file_line}`);
        const message = isString 
            ? `${prefix} ${firstArg}`
            : prefix;
        args.splice(0, 1);
        const argz = [];
        argz.push(message);
        if (data) {
            argz.push(data);
        }
        argz.concat(...args);
        if (rebuildStack) {
            argz.push({ stack: { frames, trace: stack } });
        }
        return argz;
    };
    const flush = () => {};
    const use = () => {};
    return {
        debug,
        info,
        log,
        warn,
        error,
        flush,
        use,
    };
};
const logger = SimpliCityLogger();
// const Logger = source_token
//     ? new Logtail(source_token, logOptions)
//     : devLogger



export * from "./colors";
export { logger as Logger };
